import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaRegTrashAlt, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { deleteProduct } from "../../../redux/slices/productSlice";
import { ImSpinner2 } from "react-icons/im";
import { fetchPharmacyDetail } from "../../../redux/slices/pharmacySlice";

export default function DeleteProductPharmacy({
  pId,
  id,
  name,
  image,
  category,
  description,
  price,
  type,
  page
}) {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const status = useSelector((state) => state.product?.status);

  const handleDelete = async () => {
    try {
      const res = await dispatch(deleteProduct(pId));

      await dispatch(fetchPharmacyDetail({id,page}));
      setShowModal(false);
      toast.success(res.payload.data.message);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <button type="button" onClick={() => setShowModal(true)}>
        <FaRegTrashAlt className="w-4 h-4 text-[#667085] focus:text-[#00AAFF]" />
      </button>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-4xl">
              {/*content*/}
              <div className="border-0 rounded-lg p-6 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center"
                >
                  <FaTimes className="text-gray-300 text-xl" />
                  <span className="sr-only">Close modal</span>
                </button>
                <div className="flex items-center px-8 py-4 gap-8">
                  <img
                    src={image}
                    alt="productname"
                    className="w-80 h-72 rounded-lg ring-[8px] ring-[#D9D9D9]"
                  />
                  <div className="flex flex-col gap-4 mt-6">
                    <div>
                      <h1 className="text-[28px] text-gray-800 font-medium mb-4">
                        Delete Product
                      </h1>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="text-gray-700 font-medium">Name</div>
                      <h1 className="text-base text-gray-800 font-semibold w-48 break-words text-right">
                        {name}
                      </h1>
                    </div>
                    <div className="flex justify-between items-center gap-6">
                      <div className="text-gray-700 font-medium">
                        Description
                      </div>
                      <h1 className="text-base text-gray-800 font-normal w-48 break-word text-right">
                        {description}
                      </h1>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="text-gray-700 font-medium">Price</div>
                      <h1 className="text-base text-gray-800 font-semibold">
                      <span className="mr-1">&#8358;</span>
                        {price}
                      </h1>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="text-gray-700 font-medium">Price</div>
                      <h1 className="text-base text-gray-800 font-semibold">
                        {category}
                      </h1>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="text-gray-700 font-medium">Type</div>
                      <h1 className="text-base text-gray-800 font-semibold">
                        {type}
                      </h1>
                    </div>
                    <div className="flex gap-4 justify-center">
                      <button
                        onClick={() => setShowModal(false)}
                        disabled={status === "loading"}
                        className="text-sm text-blue-500 font-semibold bg-blue-100 py-2 px-4 rounded-lg"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleDelete}
                        className="flex gap-1 rounded-lg items-center bg-[#FC0000] text-white py-2 px-4"
                      >
                        {status === "loading" ? (
                          <>
                            <ImSpinner2 className="animate-spin" />
                            <p className="text-sm font-semibold whitespace-nowrap">
                              Deleting ...
                            </p>
                          </>
                        ) : (
                          <>
                            <FaTimes className="w-4 h-4" />
                            <p className="text-sm font-semibold whitespace-nowrap">
                              Delete Product
                            </p>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
